/**
 * Wishlist Plus (Swym ATW) may inject the PDP wishlist into the 2nd gallery image.
 * Move `.swym-atw-btn-wrapper-for-img` into the first visible image `.img-ar` container.
 */
(function () {
  function getFirstMediaBlock(mainImage) {
    if (!mainImage) return null;
    var collage = mainImage.querySelector('.product-media-collage');
    var collageVisible = collage && window.getComputedStyle(collage).display !== 'none';
    if (collageVisible) {
      var firstCollage = collage.querySelector('.product-media-collage__item:first-child');
      if (firstCollage) return firstCollage;
    }
    var firstSlide = mainImage.querySelector('.slider__grid .slider__item:first-child');
    if (firstSlide) return firstSlide;
    return mainImage.querySelector('.product-media-collage__item:first-child');
  }

  /** Prefer mounting inside .img-ar (same as Swym) so top/left aligns to the photo. */
  function getWishlistMountPoint(mainImage) {
    var block = getFirstMediaBlock(mainImage);
    if (!block) return null;
    var imgAr = block.querySelector('.img-ar');
    return imgAr || block;
  }

  function getPrimaryAtwWrapper(mainImage) {
    var btn = document.getElementById('swym-atw-pdp-button');
    if (btn) {
      var w = btn.closest('.swym-atw-btn-wrapper-for-img');
      if (w) return w;
    }
    var wrappers = mainImage.querySelectorAll('.swym-atw-btn-wrapper-for-img');
    if (wrappers.length === 1) return wrappers[0];
    if (wrappers.length > 1) {
      for (var i = 0; i < wrappers.length; i++) {
        if (wrappers[i].querySelector('#swym-atw-pdp-button')) return wrappers[i];
      }
      return wrappers[0];
    }
    return null;
  }

  function moveSwymWishlist() {
    var mainImage = document.querySelector('.media-gallery .main-image');
    if (!mainImage) return;
    var mount = getWishlistMountPoint(mainImage);
    if (!mount) return;

    var wrapper = getPrimaryAtwWrapper(mainImage);
    if (!wrapper) {
      var productForm = document.querySelector('.product-info .product-form');
      if (productForm) {
        wrapper = productForm.querySelector('.swym-atw-btn-wrapper-for-img');
        if (wrapper && !mainImage.contains(wrapper)) {
          mount.appendChild(wrapper);
        }
      }
      return;
    }

    if (mount.contains(wrapper)) {
      return;
    }

    mount.appendChild(wrapper);
  }

  function init() {
    moveSwymWishlist();
    var mainImage = document.querySelector('.media-gallery .main-image');
    if (!mainImage) return;

    var obs = new MutationObserver(function () {
      moveSwymWishlist();
    });
    obs.observe(mainImage, { childList: true, subtree: true });

    var productForm = document.querySelector('.product-info .product-form');
    if (productForm) {
      obs.observe(productForm, { childList: true, subtree: true });
    }

    var debounce;
    window.addEventListener('resize', function () {
      clearTimeout(debounce);
      debounce = setTimeout(moveSwymWishlist, 150);
    });

    [400, 1200, 2500].forEach(function (ms) {
      setTimeout(moveSwymWishlist, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
